import { ReportComponentType } from '@/types';

/**
 * User-facing feature gates for implementations that remain in the codebase
 * while their navigation, creation, and rendering surfaces are unavailable.
 */
export const userFacingFeatures = {
    globalTradeSearch: false,
    marketEventsSearch: false,
    spatialReportComponents: false,
} as const;

export const isSearchDomainAvailable = (domain: string): boolean => {
    if (domain === 'trade') {
        return userFacingFeatures.globalTradeSearch;
    }

    if (domain === 'events') {
        return userFacingFeatures.marketEventsSearch;
    }

    return true;
};

export const isSpatialReportComponent = (type: ReportComponentType): boolean =>
    type === ReportComponentType.MAP || type === ReportComponentType.GLOBE;

export const isReportComponentAvailable = (type: ReportComponentType): boolean =>
    userFacingFeatures.spatialReportComponents || !isSpatialReportComponent(type);
